import { render, staticRenderFns } from "./TestsHistory.vue?vue&type=template&id=0ef4e163&scoped=true"
import script from "./TestsHistory.vue?vue&type=script&lang=js"
export * from "./TestsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef4e163",
  null
  
)

export default component.exports